export default {"src":"/_next/static/media/black-lock-icon.67449d59.svg","height":17,"width":17};